enum FinancingApiVersionEnum {
    V1 = "V1",
    V3 = "V3"
}

export default FinancingApiVersionEnum;
